<form
  [formGroup]="selectDialogForm"
  (submit)="onSubmit()">
  <div class="bn-dialog">
    @if (data.icon) {
      <div class="bn-dialog__icon bn-dialog__icon--{{ data.contextType }}">
        <fa-icon [icon]="data.icon" />
      </div>
    }
    <div class="bn-dialog__title bn-dialog__or--center">{{ data.title }}</div>
    <div class="bn-dialog__body">
      <div
        class="bn-dialog__or--center"
        [innerHtml]="data.description | sanitizeHtml: ['p', 'br', 'span', 'strong', 'b', 'em', 'i']"></div>
      <div class="my-4">
        @let store = virtualScrollConfig?.store;
        @let enabledVirtualScrollStore = !!store;
        <bn-web-ui-prime-select
          formControlName="selectedValue"
          id="select-input-dialog-dropdown"
          placeholder="Choose an Item"
          [clearable]="false"
          [disableInternalSearch]="enabledVirtualScrollStore"
          [inputName]="inputSettings?.inputName"
          [isLoading]="enabledVirtualScrollStore && store?.entitiesCurrentPage()?.isLoading"
          [items]="store?.entities() ?? selectItems"
          [readonly]="enabledVirtualScrollStore && !store?.entitiesFilter()?.libraryId"
          [searchable]="true"
          [virtualScroll]="enabledVirtualScrollStore"
          (scroll)="virtualScrollConfig?.onSelectPaginationScroll(store, $event)"
          (search)="
            virtualScrollConfig?.onSelectPaginationSearch(store, {
              search: $event,
              libraryId: store?.entitiesFilter()?.libraryId,
            })
          " />
      </div>
    </div>
    <div class="bn-dialog__actions row">
      <div class="col-6">
        <button
          bn-web-ui-button
          class="me-2"
          size="lg"
          type="submit"
          [fullWidth]="true"
          [itemStyle]="data.contextType === 'danger' ? 'danger' : 'primary'"
          [loading]="isLoading">
          {{ data.confirmButtonName || 'Apply' }}
        </button>
      </div>
      <div class="col-6">
        <button
          bn-web-ui-button
          itemStyle="stroke"
          size="lg"
          type="button"
          [fullWidth]="true"
          (click)="onCloseDialog()">
          {{ data.closeButtonName || 'Cancel' }}
        </button>
      </div>
    </div>
  </div>
</form>
